export default (leaderboard, detailName) => {
  return leaderboard.reduce((agg, curr) => {
    if (!agg) {
      agg = curr.reduce((subAgg, subCurr) => {
        if (!subAgg) {
          subAgg = subCurr.details.some((detail) => {
            const isCorrectName = detail.name === detailName;
            const hasValue =
              detail.details && detail.details[0] && detail.details[0].values && detail.details[0].values[1];
            return isCorrectName && hasValue;
          });
        }
        return subAgg;
      }, false);
    }
    return agg;
  }, false);
};
